/**
 * PC版の設定の2列（#153、docs/62 §6・★3、Figma「設定と自社情報（10/9）」⑥）。app.tsx が PC版の /settings・/settings/* をこの枠に入れる
 * （帳票デザインのエディタ /settings/paper/edit は入れない＝全面のまま。スマホ版は今どおり メニュー → 画面）。
 *   ・左 360px の列＝設定のメニュー（pages/SettingsMenu.tsx の SettingsMenu。机の地・右に 1px の罫線・上から自分でスクロール）。
 *     いまの画面の行は 地 --sel＋太字＋aria-current="page"（下の画面はその親の行。contract の settingsRowOf）
 *   ・右＝選んだ画面（真ん中に最大 760px。表の画面＝{trade}・場所・品目は右の幅いっぱい。振込口座は #155、ユーザー管理などの残り7画面は #156 で表をやめて 600px の列）
 *   ・右の画面で左の列に行がある画面は「‹ 設定」を出さない（BackButton が lib/settingsPane の top を見る）。その下の画面は今どおり「‹ 一覧」
 * 見た目は styles.css の「設定と自社情報（#153）」の節（.setlay・.setnav・.setmain）
 */
import { SETTINGS_MSG, isSettingsTopPath } from "@genbaryoku/contract";
import { useMemo, type ReactNode } from "react";
import { useLocation } from "react-router";
import { SettingsPaneContext } from "../lib/settingsPane.js";
import { SettingsMenu } from "../pages/SettingsMenu.jsx";

/** 右の幅いっぱいに使う画面（表の画面） */
const WIDE = /^\/settings\/(trades|places|items)\/?$/;

export function SettingsLayout({ children }: { children: ReactNode }) {
  const loc = useLocation();
  const top = isSettingsTopPath(loc.pathname);
  const pane = useMemo(() => ({ twoCol: true, top }), [top]);
  return (
    <SettingsPaneContext.Provider value={pane}>
      <div className="setlay" data-testid="settings-layout">
        <div className="setside">
          <nav className="setnav" aria-label={SETTINGS_MSG.title} data-testid="settings-nav">
            <h2 className="settitle">{SETTINGS_MSG.title}</h2>
            <SettingsMenu column />
          </nav>
        </div>
        <div className={"setmain" + (WIDE.test(loc.pathname) ? " is-wide" : "")}>
          <div className="setmain-in">{children}</div>
        </div>
      </div>
    </SettingsPaneContext.Provider>
  );
}
